import React, { useContext, useLayoutEffect } from 'react'
import { AssetsContext } from '../../context'
import { Button } from '@components/Button'
import { Modal, ModalHeader, ModalSubHeader, ModalContent, ModalFooter } from '@components/Modal'

export const Destroy = () => {
  const { state, actions } = useContext(AssetsContext)
  const { loading, asset, modalScrollTop } = state
  const { confirmDelete, back } = actions

  const flaggedForDeletion = asset.flagged_for_deletion
  const trackingText = flaggedForDeletion
    ? `Disconnected Asset: Delete confirm`
    : `Asset: Delete confirm`

  useLayoutEffect(() => {
    if (modalScrollTop !== undefined) window.scrollTo(0, modalScrollTop)
  }, [modalScrollTop])
  return (
    <Modal open onClose={back} small className="asset-confirmation-modal">
      <ModalHeader>Are you sure you want to delete the asset?</ModalHeader>
      <ModalSubHeader>{asset.name}</ModalSubHeader>
      <ModalContent>
        <p>This will permanently remove the asset from this scenario.</p>
      </ModalContent>
      <ModalFooter>
        <Button secondary disabled={loading} onClick={back}>NOT RIGHT NOW</Button>
        <Button primary trackAs={trackingText} disabled={loading} onClick={confirmDelete}>
          {loading ? 'Removing asset...' : `YES I'M SURE`}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
